/* Cart drawer — open/close, qty change, add to cart opens drawer */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.querySelector('.js-cart-overlay');
    const drawer = document.querySelector('.js-cart-drawer');
    const openTriggers = document.querySelectorAll('.js-cart-open');
    const closeTriggers = document.querySelectorAll('.js-cart-close');

    if (!drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openTriggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    closeTriggers.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    var cartChangeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/change.js';

    var cartUpdating = false;

    function getShippingBarWidth() {
      var fill = drawer.querySelector('.cart-drawer_shipping-fill');
      if (!fill || !fill.dataset.width) return null;
      return parseInt(fill.dataset.width, 10);
    }

    function animateShippingBars(fromWidth) {
      var start = fromWidth != null ? fromWidth : 0;
      drawer.querySelectorAll('.cart-drawer_shipping-fill').forEach(function (fill) {
        var target = fill.dataset.width;
        if (target == null || target === '') return;
        target = parseInt(target, 10);
        fill.style.width = start + '%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.style.width = target + '%';
          });
        });
      });
    }

    function updateDrawerFromSectionHtml(html) {
      if (!html) return false;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('.js-cart-drawer');
      if (newDrawer && drawer.parentNode) {
        var prevWidth = getShippingBarWidth();
        drawer.innerHTML = newDrawer.innerHTML;
        animateShippingBars(prevWidth);
        return true;
      }
      return false;
    }

    function handleDrawerClick(e) {
      /* Qty change in drawer */
      const qtyBtn = e.target.closest('.js-cart-qty-change');
      if (qtyBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (cartUpdating) return;
        const wrap = qtyBtn.closest('.cart-drawer_item');
        if (!wrap) return;

        const line = parseInt(qtyBtn.dataset.line, 10);
        const change = parseInt(qtyBtn.dataset.change, 10);
        const numEl = wrap.querySelector('.js-cart-qty-num');
        if (!numEl) return;

        var qty = parseInt(numEl.textContent, 10) + change;
        if (qty < 1) qty = 1;

        /* Optimistic update — show quantity change immediately */
        numEl.textContent = qty;

        cartUpdating = true;
        var apiId = drawer.dataset.sectionApiId || drawer.dataset.sectionId || 'cart-drawer';
        fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: line, quantity: qty, sections: apiId })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var updated = data.sections && data.sections['cart-drawer'] && updateDrawerFromSectionHtml(data.sections['cart-drawer']);
            if (!updated && window.refreshCartDrawer) {
              setTimeout(function () {
                window.refreshCartDrawer().catch(function () {}).finally(function () { cartUpdating = false; });
              }, 500);
            } else {
              cartUpdating = false;
            }
          })
          .catch(function () {
            numEl.textContent = qty - change;
            cartUpdating = false;
          });
        return;
      }

      /* Remove item from cart */
      const removeBtn = e.target.closest('.js-cart-remove');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (cartUpdating) return;
        const line = parseInt(removeBtn.dataset.line, 10);
        if (isNaN(line)) return;

        var itemRow = removeBtn.closest('.cart-drawer_item');
        removeBtn.disabled = true;
        if (itemRow) itemRow.style.opacity = '0.5';

        cartUpdating = true;
        var apiId = drawer.dataset.sectionApiId || drawer.dataset.sectionId || 'cart-drawer';
        fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: line, quantity: 0, sections: apiId })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var updated = data.sections && data.sections['cart-drawer'] && updateDrawerFromSectionHtml(data.sections['cart-drawer']);
            if (!updated && window.refreshCartDrawer) {
              setTimeout(function () {
                window.refreshCartDrawer().catch(function () {}).finally(function () { cartUpdating = false; });
              }, 600);
            } else {
              cartUpdating = false;
            }
          })
          .catch(function () {
            removeBtn.disabled = false;
            if (itemRow) itemRow.style.opacity = '';
            cartUpdating = false;
          });
      }
    }

    drawer.addEventListener('click', handleDrawerClick);

    /* Animate shipping bar on initial load */
    animateShippingBars();

    /* Expose for featured-products add to cart */
    window.openCartDrawer = openDrawer;
    window.animateCartDrawerShippingBars = animateShippingBars;

    var refreshThrottleMs = 3000;
    var lastRefreshAt = 0;
    var refreshPending = false;

    window.refreshCartDrawer = function (sectionId) {
      var now = Date.now();
      var elapsed = now - lastRefreshAt;

      function doFetch() {
        if (refreshPending) return Promise.resolve();
        refreshPending = true;
        lastRefreshAt = Date.now();

        var apiId = sectionId || drawer.dataset.sectionApiId || drawer.dataset.sectionId || 'cart-drawer';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var url = root + '?sections=' + apiId + '&_=' + Date.now();

        return fetch(url, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            if (r.status === 429) {
              refreshThrottleMs = Math.min(refreshThrottleMs * 1.5, 8000);
              throw new Error('Rate limited');
            }
            return r.json();
          })
          .then(function (data) {
            var html = data.sections && (data.sections[apiId] || data.sections['cart-drawer']);
            if (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var newDrawer = doc.querySelector('.js-cart-drawer');
              if (newDrawer && drawer.parentNode) {
                var prevWidth = getShippingBarWidth();
                drawer.innerHTML = newDrawer.innerHTML;
                animateShippingBars(prevWidth);
              }
            }
          })
          .catch(function () {})
          .finally(function () {
            refreshPending = false;
          });
      }

      if (elapsed >= refreshThrottleMs) {
        return doFetch();
      }
      var delay = refreshThrottleMs - elapsed;
      return new Promise(function (resolve) {
        setTimeout(function () {
          doFetch().then(resolve).catch(resolve);
        }, delay);
      });
    };
  });
})();
